import React, { useEffect, useState } from 'react';
import ProjectList from './ProjectList';
import Button from '@mui/material/Button';
import { Box, Paper, Grid } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Typography } from '@mui/material';
import NewProject from './NewProject';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { fetchUsers } from '../UserManagement/UserSlice';
import CircularProgress from '@mui/material/CircularProgress';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

type ProjectDetailParams = {
  id: string;
};

function ProjectDetail() {
  const dispatch = useAppDispatch();
  let navigate = useNavigate();
  const { projects } = useAppSelector<any>((state) => state.projectmanagement);
  let { id } = useParams<ProjectDetailParams>();
  const currentProject = projects.find((project: any) => project.id === id);
  const [showNew, setShowNew] = useState(false);

  const backToProjectManagement = () => {
    navigate(-1);
  };

  return (
    <>
      {!currentProject ? (
        <Grid
          sx={{
            // backgroundColor: 'rgba(0,0,0,0.8)',
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <CircularProgress size={100} thickness={4} sx={{ color: 'var(--color-ash-highlight)' }} />
        </Grid>
      ) : (
        <Grid display="flex" flexDirection="column" height="100%">
          <Grid display="flex" justifyContent="space-between" mt={3}>
            <Grid display="flex" alignItems="center" width="100%"></Grid>
          </Grid>
          <Grid sx={{ width: '100%' }} container spacing={3}>
            <Grid item xs={4}>
              <Button
                className="bold-text"
                sx={{
                  bgcolor: 'var(--color-ocean-default)',
                  color: 'var(--color-offwhite)',
                  py: '20px',
                  ':hover': {
                    bgcolor: 'var(--color-ocean-highlight)',
                    color: 'var(--color-dark-gray)'
                  },
                  height: '56px',
                  mr: 2
                }}
                onClick={() => {
                  backToProjectManagement();
                }}
                fullWidth
                size="large"
                variant="contained"
                startIcon={<ArrowBackIcon />}
              >
                BACK TO House MANAGEMENT
              </Button>
            </Grid>
            <Grid item xs={8}>
              <Typography
                className="bold-text"
                sx={{
                  color: 'var(--color-ocean-highlight)',
                  fontSize: '32px'
                }}
                align="right"
                variant="h3"
              >
                {currentProject?.source ? 'Project' : `Project ${currentProject.label}`}
              </Typography>
            </Grid>
          </Grid>
          <Grid sx={{ width: '100%' }} container spacing={3}>
            <Grid item xs={4}>
              <Paper
                sx={{
                  padding: '20px 30px',
                  backgroundColor: 'black',
                  borderColor: 'var(--color-ocean-default)',
                  borderWidth: '2px',
                  height: '100%',
                  overflow: 'auto',
                  mt: 3
                }}
                variant="outlined"
              >
                <Typography
                  sx={{ color: 'var(--color-offwhite)', fontSize: '24px' }}
                  align="left"
                  variant="h4"
                  gutterBottom
                >
                  House Details
                </Typography>
              </Paper>
              <Paper
                sx={{
                  padding: '20px 30px',
                  backgroundColor: 'black',
                  borderColor: 'var(--color-ocean-default)',
                  borderWidth: '2px',
                  height: '100%',
                  overflow: 'auto',
                  mt: 3
                }}
                variant="outlined"
              >
                <Typography
                  sx={{ color: 'var(--color-offwhite)', fontSize: '24px' }}
                  align="left"
                  variant="h4"
                  gutterBottom
                >
                  House Admins
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={8}>
              <Paper
                sx={{
                  padding: '20px 30px',
                  backgroundColor: 'var(--color-dark-gray)',
                  height: '100%',
                  display: 'flex',
                  overflow: 'auto',
                  mt: 3
                }}
              >
                <Typography
                  sx={{ color: 'var(--color-offwhite)', fontSize: '24px' }}
                  align="left"
                  variant="h4"
                  gutterBottom
                >
                  Project Members
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default ProjectDetail;
